// Imports
import MicroModal from "micromodal";

class Modal {
    constructor() {
    }
    init() {
        MicroModal.init({
            openClass: '_open', // Custom class to be applied when modal is open
            openTrigger: 'data-modal-open', // Custom data attribute to open modal
            closeTrigger: 'data-modal-close', // Custom data attribute to close modal
            onShow: (modal, trigger, event) => {
                // This is fired when the modal is opening.

                // Get trigger or target element based on where Safari or not
                let trig = window.APP.env.isSafari ? event.target : trigger;

                console.log({trig});

                // Disable scrolling
                window.APP.modules.PageScrolling.lock(modal);

                const modalContent = modal.querySelector('.modal-content');
                let btn = document.getElementById(trig.id);

                console.log({modalContent});
                console.log({btn});

                if (!modalContent) {
                    console.error('Element with class .modal-content not found');
                }
                if (!btn) {
                    console.error('btn element not found with ID: ' + trig.id);
                }

                let imageSettings = btn.hasAttribute('data-image') ? btn.getAttribute('data-image') : null;
                let videoSettings = btn.hasAttribute('data-video') ? btn.getAttribute('data-video') : null;
                let floorplanSettings = btn.hasAttribute('data-floorplan') ? btn.getAttribute('data-floorplan') : null;

                console.log({imageSettings});
                console.log({videoSettings});
                console.log({floorplanSettings});

                // Image
                if (imageSettings) {
                    // Create image element
                    const img = document.createElement('img');

                    // Add a class to the image
                    img.classList.add('object-contain h-full w-full');

                    // Add the image URL to the
                    img.src = imageSettings;

                    // Append the iframe to the modal content if the element exists
                    if (modalContent) {
                        modalContent.appendChild(img);
                    }
                }

                // Video
                if (videoSettings) {
                    // Create iframe element
                    let iframe = document.createElement('iframe');

                    // Add a class to the iframe
                    iframe.classList.add('reframe');

                    // Split the videoSettings string by a comma
                    let [videoType, videoID] = videoSettings.split(',');
                    let videoUrl = '';

                    if (videoType === 'vimeo') {
                        videoUrl = `https://player.vimeo.com/video/${videoID}?title=0&byline=0&portrait=0&controls=1&autoplay=1`;
                    }
                    else if (videoType === 'youtube') {
                        videoUrl = `https://www.youtube.com/embed/${videoID}?showinfo=0&rel=0&iv_load_policy=3&start=0&controls=1&autoplay=1`;
                    }

                    // Add URL to iframe
                    iframe.src = videoUrl;

                    // Append the iframe to the modal content if the element exists
                    if (modalContent) {
                        modalContent.appendChild(iframe);
                    }
                }

                // Floor plan
                if (floorplanSettings) {
                    // Split the floorplan string by a comma
                    let [floorplan, keyplan] = floorplanSettings.split(',');

                    let container = document.createElement('div');
                    container.className = 'gap-5 flex flex-col justify-center h-full max-w-screen-2xl mx-auto w-full md:flex-row';

                    if (floorplan) {
                        let floorPlanImage = document.createElement('img');
                        floorPlanImage.className = 'floor-plan-preview-image';
                        floorPlanImage.src = floorplan;

                        // Add to container
                        container.appendChild(floorPlanImage);
                    }

                    if (keyplan) {
                        let keyPlanImage = document.createElement('img');
                        keyPlanImage.className = 'floor-plan-preview-keyplan';
                        keyPlanImage.src = keyplan;

                        // Add to container
                        container.appendChild(keyPlanImage);
                    }

                    // Append the container to the modal content if the element exists
                    if (modalContent) {
                        modalContent.appendChild(container);
                    }
                }
            },
            onClose: modal => {
                //This is fired when the modal is closing.
                // The function receives the modal object as the first parameter and the trigger element as the second parameter.

                let modalContent = modal.querySelector('.modal-content');
                if (modalContent) {
                    modalContent.innerHTML = ''; // Remove content
                }

                // Enable scrolling
                window.APP.modules.PageScrolling.unlock(modal);
            }
        });
    }
}

export default new Modal();



